import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Button, message,Modal } from 'antd'
import { ExclamationOutlined } from '@ant-design/icons'
import '../../css/patient.scss'
import { constants } from '../../constants'
import _ from 'lodash'
import moment from 'moment'
import { Link, useHistory } from 'react-router-dom'
import {
  getAllDevices,
  getDeviceSchedule,
} from '../../store/action/device.action'
import { getPatientNots, getReport ,getActivityLog} from '../../store/action/patient.action'
import PatientNotifyModal from './patient.notify.modal'
import AddEvent from './patient.events.add'
import EditCareGiver from './patient.caregiver.edit'
import EditShipAddress from './patient.shipaddress.edit'
import util from '../../util/util'
import { getSchedule } from '../../store/action/schedule.action'
import { setPatient } from '../../store/action/patient.action'
import CaseModal from './case.modal'
import ActivityLog from './activity.log'

const PatientButtons = (props) => {
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const [caseOpen, setCaseOpen] = useState(false)
  const [openCG, setOpenCG] = useState(false)
  const [openAddr, setOpenAddr] = useState(false)
  const [addEvent, setEvent] = useState(undefined)
  const [editCaregiver, setEditCaregiver] = useState(undefined)
  const [editShipAddress, setEditShipAddress] = useState(undefined)
  const [logOpen,setLogOpen] = useState(false);
  var { exerciseSchedule, feedbackSchedule, _id, surgery, firstname, lastname, dailyshift,careplan, progressTestGoalOverrides } =
    props.patient

  const [healthcoach, setHealthcoach] = useState(
    props.role == constants.ROLE.COMPANY_HEALTHCOACH
  )

  var printReport = () => props.getReport(props.patient._id)
  var handleSuccess = (data) => {
    data && message.success('Notification sent.')
    props.getNotifications(props.patient._id)
    setOpen(false)
    setOpenCG(false)
    setOpenAddr(false)
  }

  var handleScheduleEdit = (e) =>
    history.push({
      pathname: '/patient/schedule/' + _id,
      state: {
        patient: {
          firstname,
          lastname,
          surgery,
          careplan,
          _id,
          dailyshift: {
            start: {
              hour: dailyshift?.start?.hour,
              minute: dailyshift?.start?.minute,
            },
            end: {
              hour: dailyshift?.end?.hour,
              minute: dailyshift?.end?.minute,
            },
          },
        },
      },
    })

  var handlefeedScheduleEdit = (e) =>
    history.push({
      pathname: '/patient/questionnaireschedule/' + _id,
      state: {
        patient: {
          firstname,
          lastname,
          surgery,
          careplan,
          _id,
          dailyshift: {
            start: {
              hour: dailyshift?.start?.hour,
              minute: dailyshift?.start?.minute,
            },
            end: {
              hour: dailyshift?.end?.hour,
              minute: dailyshift?.end?.minute,
            },
          },
        },
      },
    })

    const isSameSurgeon=()=>{
      if(!props.user?.surgeon)return true; //Admin
      // console.log(props.user?.surgeon,"surgeonn",props.patient?.surgeon?._id,props.user?.surgeon==props.patient?.surgeon?._id)
    return props.user?.surgeon==props.patient?.surgeon?._id

    }
  var handleDeviceScheduleEdit = async (e) => {
    const assingedDevices = await props.getAllDevices({
      age_group: props.patient.age,
      surgery_type: props.patient.surgery.type,
      gender: props.patient.gender,
    })
    // const schedules = await props.getDeviceSchedule(props.patient._id)
    history.push({
      pathname: '/patient/deviceschedule/' + _id,
      state: {
        devices: props.assignedDevices,
        patient: {
          firstname,
          lastname,
          surgery,
          careplan,
          _id,
          progressTestGoalOverrides,
          dailyshift: {
            start: {
              hour: dailyshift?.start?.hour,
              minute: dailyshift?.start?.minute,
            },
            end: {
              hour: dailyshift?.end?.hour,
              minute: dailyshift?.end?.minute,
            },
          },
        },
      },
    })
  }
  var disableEventBtn =
    props.dayView &&
    !moment(props.date).startOf('day').isSameOrAfter(moment().startOf('day'))
  var disableDeviceEdit =
    _.find(props.patient?.deviceSchedule?.assigneddevices, {
      isDeleted: false,
    }) == undefined

  const fetchActivityLog = ()=>{
     props.getActivityLog({patientid:props.patient?._id})
     setLogOpen(true);
  }

  
  return (
    <>
      <Col className='patientBtnsContainer'>
        {/* <Row >
                <Button className="greyBtn">
                    RESEND ACCESS CODE
                </Button>
            </Row> */}
        <Row>
          <Button
            disabled={healthcoach}
            className={healthcoach ? 'greyBtn' : 'greyBtn darkblue'}
            onClick={printReport}
          >
            PRINT REPORT
          </Button>
        </Row>
        {/* <Row >
                <Button className={healthcoach? "greyBtn":"greyBtn darkblue"} disabled={healthcoach} onClick={ () => setEditCaregiver(true)}>
                    EDIT CAREGIVER
                </Button>
            </Row>
             <Row >
                <Button className="greyBtn darkblue"  onClick={() => setEditShipAddress(true)}>
                    EDIT SHIP ADDRESS
                </Button>
            </Row> */}
        <Row>
          <Button className='greyBtn darkblue' onClick={() => setOpen(true)}>
            NOTIFY
          </Button>
        </Row>
        <Row>
          <Button
            disabled={disableEventBtn || healthcoach}
            className={
              disableEventBtn || healthcoach ? 'greyBtn' : 'greyBtn darkblue'
            }
            onClick={(e) => setEvent(true)}
          >
            ADD REMINDER
          </Button>
        </Row>
        <Row>
          <Button
            onClick={handleScheduleEdit}
            disabled={healthcoach}
            className={healthcoach ? 'greyBtn' : 'greyBtn darkblue'}            
          >
            {!exerciseSchedule?.isEditable  ? 'ADD EXERCISE' : ' EDIT EXERCISE SCHEDULE'}
            
          </Button>
        </Row>
        <Row>
          <Button
            onClick={handleDeviceScheduleEdit}
            className={healthcoach ? 'greyBtn' : 'greyBtn darkblue'}
            disabled={healthcoach}
          >
            {disableDeviceEdit ? 'ADD DEVICE' : ' EDIT MEASUREMENT SCHEDULE'}
          </Button>
        </Row>
        <Row>
          <Button
            onClick={handlefeedScheduleEdit}
            className={healthcoach ? 'greyBtn' : 'greyBtn darkblue'}
            disabled={healthcoach}
          >
            {!feedbackSchedule?.isEditable ? 'ADD QUESTIONNAIRE' : ' EDIT QUESTIONNAIRE SCHEDULE'}
          </Button>
        </Row>
        <Row hidden={props.role == constants.ROLE.COMPANY_ADMIN} disabled={!isSameSurgeon()}>
          <Button
            className={!isSameSurgeon() ? 'greyBtn' : 'greyBtn darkblue'}
            onClick={() => isSameSurgeon()  && setCaseOpen(true)}
          >
            START CONVERSATION
          </Button>
        </Row>
        <Row >
          <Button
            className={'greyBtn darkblue'}
            onClick={() => fetchActivityLog()}
          >
            ACTIVITY LOG
          </Button>
        </Row>
        {/* Billing button - only for COMPANY_ADMIN and COMPANY_HEALTHCOACH */}
        {(props.role == constants.ROLE.COMPANY_ADMIN || 
          props.role == constants.ROLE.COMPANY_HEALTHCOACH) && (
          <Row>
            <Button
              className={'greyBtn darkblue'}
              onClick={() => history.push(`/patient/${props.patient?._id}/billing`)}
            >
              BILLING
            </Button>
          </Row>
        )}
        <Link to='/patient'>
          <Row>
            <Button onClick={props.setPatient} className='greyBtn darkblue'>
              BACK
            </Button>
          </Row>
        </Link>
      </Col>
      <PatientNotifyModal
        patientids={[props.patient?._id]}
        visible={open}
        onClose={() => setOpen(false)}
        onSuccess={handleSuccess}
      />
      <CaseModal
        visible={caseOpen}
        onClose={() => setCaseOpen(false)}
        onSuccess={handleSuccess}
      />
      <AddEvent
        patientid={props.patient?._id}
        visible={addEvent}
        onClose={setEvent}
        onSuccess={setEvent}
        date={props.dayView ? props.date : undefined}
      />
      <Modal
        className={'filterModal'}
        title='Activity Log'
        visible={logOpen}
        bordered={true}
        width={'80%'}
        onCancel={() => setLogOpen(false)}
        footer={null}
      >
        <ActivityLog   onCancel={() => setLogOpen(false)} />
      </Modal>      
      {/* <EditCareGiver 
            patientid={props.patient?._id}
            visible={editCaregiver}
            onClose={setEditCaregiver}
            onSuccess={setEditCaregiver}
            date={props.dayView ? props.date : undefined}
        />
         <EditShipAddress 
            patientid={props.patient?._id}
            visible={editShipAddress}
            onClose={setEditShipAddress}
            onSuccess={setEditShipAddress}
            date={props.dayView ? props.date : undefined}
        /> */}
    </>
  )
}

PatientButtons.propTypes = {
  patient: PropTypes.object,
  getReport: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
    assignedDevices: state.device.assignedDevices,
    role: state.profile.user.role,
    user: state.profile.user,
    activitylogs:state.patient.activitylogs,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getReport: (id) => dispatch(getReport(id, true)),
    getNotifications: (id) => dispatch(getPatientNots(id)),
    getAllDevices: (criteria) => dispatch(getAllDevices(criteria)),
    getDeviceSchedule: (patientid) => dispatch(getDeviceSchedule(patientid)),
    setPatient: () => dispatch(setPatient({})),
    getActivityLog: (input) => dispatch(getActivityLog(input)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientButtons)
